import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subject } from 'rxjs';
import { distinctUntilChanged, map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { ContentService } from 'src/app/content.service';

@Component({
  selector: 'app-public-ruteplan',
  templateUrl: './public-ruteplan.component.html',
  styleUrls: ['./public-ruteplan.component.scss']
})
export class PublicRuteplanComponent implements OnInit, OnDestroy {

  ringId;
  periodOptions;
  periodSelectForm = new FormGroup({
    year: new FormControl( new Date().getFullYear() )
  });

  weekdays = [];
  ring;
  ruteplan;
  ruteplanYear;

  private destroyed = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private contentService: ContentService
  ) {}

  ngOnInit() {
    this.contentService.fetchContent('/public/ruteplan/aar')
      .pipe( takeUntil(this.destroyed) )
      .subscribe( res => {
        this.periodOptions = res;
        this.periodSelectForm.patchValue({ year: Math.max(...res) });
      });

    combineLatest([
      this.route.params.pipe(
        map( params => params.ringId ),
        distinctUntilChanged()
      ),
      this.periodSelectForm.valueChanges.pipe(
        map( ch => ch.year ),
        startWith( this.periodSelectForm.value.year )
      )
    ]).pipe(
      switchMap( ([ringId, year]) => {
        this.ringId = ringId;
        delete this.ruteplan;
        return this.contentService.fetchContent(
          `/public/ring/${ringId}/ruteplan?from=${year}-01-01&to=${year}-12-31`
        ).pipe( map( plan => ({ plan, year }) ) );
      }),
      takeUntil(this.destroyed)
    ).subscribe( ({ plan, year }) => {
      this.ruteplanYear = year;
      this.parseRuteplan(plan);
    });
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }

  parseRuteplan(plan) {
    this.ring = plan.ring;
    // spillested_id => sted
    const steder = {};
    plan.spillesteder.forEach(sted => steder[sted.id] = sted);
    // program_id => program_nr
    const progs = {};
    plan.program.forEach(prog => progs[prog.id] = prog.nr);

    // fyll inn programnummer og spillesteder
    plan.ruteplan.forEach( plan => {
      plan.program_nr = progs[plan.program_id] || 'n/a';
      // dager med spillested_id får spillested:
      plan.days.filter(
        day => !!day.spillested_id
      ).forEach(
        day => day.spillested = steder[day.spillested_id]
      );
    });
    this.ruteplan = plan.ruteplan;
    // Finn planen med flest dager og generer dagnavn-array som matcher antall rader
    const startdag = this.toTitleCase(this.ring.startdag || 'fredag');
    const rader = Math.max( ...plan.ruteplan.map( plan => plan.days.length ));
    const dager = ['Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag', 'Søndag'];
    const start = dager.indexOf(startdag);
    this.weekdays.length = 0;
    for (let i = 0; i < rader; i++) {
      this.weekdays.push(
        dager[ (start + i) % 7 ]
      );
    }
  }

  private toTitleCase(str) {
    return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
  }

}
